/* KLIK money runtime (bugs-price-facts, v2).
   1. window.KlikMoney: the one JS money formatter, same rules as snippets/klik-money.liquid (PACKAGES §3.1):
      browse = whole riyals (round half up), exact = what checkout charges (2 decimals only when not .00),
      number = plain decimal for data, text = "SAR 3,188" / "3,188 ريال". The whole-riyal switch and the campaign
      come from the [data-kc-config] JSON (snippets/klik-campaign.liquid, part 'config').
   2. window.KlikFacts: the shop facts (lead time, cancellation, tax, warranty, delivery, returns, BNPL) printed by
      snippets/klik-fact.liquid (part 'json') for scripts, in the page language.
   3. The riyal glyph for prices that older scripts still print as text (the Motion cart's money format, "SAR …",
      Intl "ر.س.") and Western digits for Arabic-Indic digits. Server prices already carry the glyph markup, so this is a
      fallback for late text, scoped (PF-13): it walks and observes only #MainContent, the cart drawer and the header
      search results, plus overlays that scripts append to <body> (each is processed and observed when it arrives); the
      header, menu, footer and announcement are never walked. Converted text follows K-012: whole riyals while
      browsing, the exact amount (2 decimals only when not .00) in the cart drawer, on /cart and inside
      [data-klik-money-exact]. It never walks or reacts inside the DPO form (#itoris_dynamicproductoptions) or the
      native option sources; attribute changes are observed on Arabic pages only. On home, collection, search and
      content pages the #MainContent observer is disconnected once the page has settled (PF-13). New code prints through
      KlikMoney instead (no text to convert). Money markup: glyph (aria-hidden) + amount + visually hidden " SAR" /
      " ريال" (R-1), the same as snippets/klik-money.liquid. */
(function () {
  'use strict';

  /* ---------- KlikMoney ---------- */
  var config = null;
  function readConfig() {
    if (config) return config;
    try { config = JSON.parse((document.querySelector('[data-kc-config]') || {}).textContent || '{}') || {}; } catch (_) { config = {}; }
    return config;
  }
  function isArabic() { return (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0; }
  var groupWhole = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
  var groupExact = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function campaign(cents, now) {
    var c = readConfig();
    var base = Math.round(Number(cents));
    // startMs / endMs: the server's instants (klik-campaign config); the ISO strings are the fallback.
    // Same rule as klik-campaign.js state() and KlikPricePresentation.price(): endMs null = no end.
    var start = c.startMs > 0 ? c.startMs : Date.parse(c.start);
    var end = c.endMs === null || (c.endMs === undefined && c.end === null) ? Infinity : (c.endMs > 0 ? c.endMs : Date.parse(c.end));
    var percent = Number(c.percent);
    now = now || Date.now();
    var active = c.enabled === true && Number.isFinite(start) && (end === Infinity || Number.isFinite(end)) && end > start &&
      now >= start && now < end && /^[A-Za-z0-9_-]{3,32}$/.test(c.code || '') && percent > 0 && percent <= 100;
    if (!Number.isSafeInteger(base) || base <= 0 || !active) return { current: base, saving: 0, percent: 0, code: '', active: false };
    var saving = Math.floor(base * Math.round(percent * 10000) / 1000000);
    return { current: base - saving, saving: saving, percent: percent, code: c.code, active: true };
  }
  function shown(cents, options) {
    options = options || {};
    var value = Math.round(Number(cents)) || 0;
    if (options.campaign) value = campaign(value).current;
    var mode = options.mode || 'browse';
    if (mode === 'exact' || options.rounding === 'exact' || readConfig().wholeRiyals === false) return value;
    return Math.round(value / 100) * 100;
  }
  function format(cents, options) {
    options = options || {};
    var value = shown(cents, options);
    if (options.mode === 'number') return value % 100 ? (value / 100).toFixed(2) : String(value / 100);
    return value % 100 ? groupExact.format(value / 100) : groupWhole.format(value / 100);
  }
  function text(cents, options) {
    var amount = format(cents, Object.assign({}, options || {}, { mode: options && options.mode === 'exact' ? 'exact' : 'browse' }));
    return isArabic() ? amount + ' ريال' : 'SAR ' + amount;
  }
  function node(cents, options) {
    return createPrice(format(cents, Object.assign({}, options || {}, { mode: options && options.mode === 'exact' ? 'exact' : 'browse' })), true);
  }
  function html(cents, options) { return node(cents, options).outerHTML; }

  /* ---------- KlikFacts ---------- */
  var facts = null;
  function fact(key, form) {
    if (!facts) {
      try { facts = JSON.parse((document.querySelector('script[data-klik-facts]') || {}).textContent || '{}') || {}; } catch (_) { facts = {}; }
    }
    var entry = facts[key];
    return entry ? entry[form || 'long'] || entry.long || '' : '';
  }

  /* ---------- glyph + Western digits for late text ---------- */
  // "ر.س" only when it is not inside a word ("كرسي", "رسوم", "أرسل" are not money).
  var currencyToken = '(?:\\b(?:SAR|SR)\\b|ر\\s*\\.?\\s*س(?![\\u0621-\\u064A])\\s*\\.?)';
  var arabicLetter = /[\u0621-\u064A]/;
  var digit = '[0-9\\u0660-\\u0669\\u06F0-\\u06F9]';
  var amount = '[-\\u2212]?' + digit + '+(?:[.,\\u066B\\u066C]' + digit + '+)*';
  var pricePattern = new RegExp('(?:' + currencyToken + '\\s*(' + amount + ')|(' + amount + ')\\s*' + currencyToken + ')', 'giu');
  var displayIgnoredParent = 'script, style, textarea, input, select, option, noscript, template, code, pre, svg, [contenteditable], [data-klik-riyal-ignore], .furniture-native-source, .sofa-native-source, .dpo-container, #itoris_dynamicproductoptions';
  var ignoredParent = displayIgnoredParent + ', .klik-riyal-price';
  var displayAttributes = ['aria-label', 'aria-valuetext', 'alt', 'title', 'placeholder'];
  var attributeSelector = '[aria-label], [aria-valuetext], [alt], [title], [placeholder]';
  var attributeIgnoredParent = 'script, style, noscript, template, code, pre, [contenteditable]';
  var nonWesternNumeral = /[\u0660-\u0669\u06F0-\u06F9\u066B\u066C]/;
  var currencyCandidate = new RegExp(currencyToken, 'iu');
  var candidate = { test: function (t) { return nonWesternNumeral.test(t) || currencyCandidate.test(t); } };
  // Subtrees that are never read or changed (numerals included): the DPO form and the native option sources.
  var skipTags = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, TEMPLATE: 1, CODE: 1, PRE: 1 };
  var skipSelector = '#itoris_dynamicproductoptions, .furniture-native-source, .sofa-native-source';
  function skipped(element) {
    if (skipTags[element.tagName] || element.id === 'itoris_dynamicproductoptions') return true;
    if (element.isContentEditable && element.getAttribute('contenteditable') !== null) return true;
    var list = element.classList;
    // .klik-riyal-price is already final markup (server or KlikMoney): its hidden " SAR" text is not walked again.
    return !!list && (list.contains('furniture-native-source') || list.contains('sofa-native-source') || list.contains('klik-riyal-price'));
  }
  // The skipped roots on the page (the DPO form appears late): a mutation inside one is dropped with one native
  // contains() per root instead of a selector walk per record (the DPO build sends thousands of records).
  var skipRoots = [];
  function rememberSkipRoot(element) {
    skipRoots = skipRoots.filter(function (root) { return root.isConnected; });
    if (skipRoots.indexOf(element) < 0) skipRoots.push(element);
  }
  function inSkipRoot(node) {
    for (var i = 0; i < skipRoots.length; i++) if (skipRoots[i].contains(node)) return true;
    return false;
  }
  function insideSkipped(element) {
    return inSkipRoot(element) || !!element.closest(skipSelector) || !!element.closest('script, style, textarea, noscript, template, code, pre, [contenteditable]');
  }

  function localizeStartingLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var expected = isArabic() ? 'يبدأ من' : 'From';
    var labels = [];
    if (root && root.nodeType === 1 && root.matches('[data-klik-starting-label]')) labels.push(root);
    Array.prototype.push.apply(labels, scope.querySelectorAll('[data-klik-starting-label]'));
    labels.forEach(function (label) {
      if (label.closest(displayIgnoredParent)) return;
      if (label.textContent !== expected) label.textContent = expected;
      label.setAttribute('data-wg-notranslate', '');
    });
  }

  function westernAmount(amountText) {
    return amountText.replace(/[\u0660-\u0669\u06F0-\u06F9]/g, function (digitText) {
      var code = digitText.charCodeAt(0);
      return String(code >= 0x06F0 ? code - 0x06F0 : code - 0x0660);
    }).replace(/([0-9])\u066B(?=[0-9])/g, '$1.').replace(/([0-9])\u066C(?=[0-9])/g, '$1,');
  }

  function normalizeAttributes(element) {
    displayAttributes.forEach(function (name) {
      var value = element.getAttribute(name);
      if (value === null || !nonWesternNumeral.test(value) || element.closest(attributeIgnoredParent)) return;
      var normalized = westernAmount(value);
      if (normalized !== value) element.setAttribute(name, normalized);
    });
  }
  function normalizeDisplayAttributes(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(attributeSelector)) normalizeAttributes(root);
    var list = root.querySelectorAll(attributeSelector);
    for (var i = 0; i < list.length; i++) {
      var element = list[i];
      for (var a = 0; a < displayAttributes.length; a++) {
        var value = element.getAttribute(displayAttributes[a]);
        if (value !== null && nonWesternNumeral.test(value)) { if (!insideSkipped(element)) normalizeAttributes(element); break; }
      }
    }
  }

  // Late text outside the cart follows the browse rule (whole riyals); the cart keeps the exact amount.
  // v3 CRO fix: the studio review step ([data-klik-money-exact]) browses in whole riyals like the rest of the studio,
  // so the total never changes form before the cart; the cart, its sheet and checkout keep the exact amount.
  var exactSelector = '#CartDrawer, form[action$="/cart"], .cart__item, .klik-cart-added';
  function exactSurface(element) {
    return document.body.classList.contains('template-cart') || !!(element && element.closest(exactSelector));
  }
  function browseText(amountText) {
    var value = Number(amountText.replace(/,/g, ''));
    if (!isFinite(value) || readConfig().wholeRiyals === false) return amountText.replace(/\.00$/, '');
    return groupWhole.format(Math.round(value));
  }
  function createPrice(amountText, exact) {
    var price = document.createElement('span');
    var symbol = document.createElement('span');
    var value = document.createElement('span');
    var currency = document.createElement('span');
    price.className = 'klik-riyal-price';
    price.setAttribute('dir', 'ltr');
    // Same markup as snippets/klik-money.liquid (R-1): the glyph is decoration, the currency is visually hidden text.
    symbol.className = 'klik-riyal-symbol';
    symbol.setAttribute('aria-hidden', 'true');
    value.className = 'klik-riyal-amount';
    // Exact rule: 2 decimals only when they are not .00. Browse rule: whole riyals.
    var western = westernAmount(amountText);
    value.textContent = exact ? western.replace(/\.00$/, '') : browseText(western);
    currency.className = 'visually-hidden';
    currency.textContent = isArabic() ? ' ريال ' : ' SAR ';
    price.appendChild(symbol);
    price.appendChild(value);
    price.appendChild(currency);
    return price;
  }

  function replaceTextNode(node) {
    var parent = node.parentElement;
    var text = node.nodeValue;
    var fragment;
    var match;
    var lastIndex = 0;

    if (!parent || !text || !candidate.test(text)) return;
    text = westernAmount(text);
    if (text !== node.nodeValue) node.nodeValue = text;
    if (!currencyCandidate.test(text)) return;
    var matches = [];
    pricePattern.lastIndex = 0;
    while ((match = pricePattern.exec(text))) {
      // token first ("ر.س 300"): not when the token ends a word ("فارس 2").
      if (match[1] !== undefined && match.index > 0 && arabicLetter.test(text.charAt(match.index - 1))) continue;
      matches.push(match);
    }
    if (!matches.length || parent.closest(ignoredParent)) return;
    var exact = exactSurface(parent);

    fragment = document.createDocumentFragment();
    matches.forEach(function (m) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex, m.index)));
      fragment.appendChild(createPrice(m[1] || m[2], exact));
      lastIndex = m.index + m[0].length;
    });
    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    node.parentNode.replaceChild(fragment, node);
  }

  var arabicPage = false;
  function process(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (!root.parentElement || insideSkipped(root.parentElement)) return;
      if (root.parentElement.matches('[data-klik-starting-label]')) localizeStartingLabels(root.parentElement);
      replaceTextNode(root);
      return;
    }
    if (root.nodeType !== 1 || skipped(root)) return;
    if (arabicPage) normalizeDisplayAttributes(root);
    if (root.matches('[data-klik-starting-label]') || root.querySelector('[data-klik-starting-label]')) localizeStartingLabels(root);
    var nodes = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeType === 1) return skipped(n) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        return candidate.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var current;
    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(replaceTextNode);
  }

  // The scoped roots (PF-13): the main content, and the cart drawer and search results in the header.
  var overlaySkip = { SCRIPT: 1, STYLE: 1, LINK: 1, META: 1, NOSCRIPT: 1, TEMPLATE: 1, IFRAME: 1, CANVAS: 1, IMG: 1, SVG: 1, VIDEO: 1, INPUT: 1 };
  function scopedRoots(body) {
    var roots = [];
    var main = document.getElementById('MainContent');
    if (main) roots.push(main);
    ['CartDrawer', 'KlikSearchResults'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element && !roots.some(function (root) { return root.contains(element); })) roots.push(element);
    });
    return roots.length ? roots : [body];
  }

  function start() {
    var body = document.body;
    if (!body) return;
    arabicPage = isArabic();
    var roots = scopedRoots(body);
    roots.forEach(function (root) { Array.prototype.forEach.call(root.querySelectorAll(skipSelector), rememberSkipRoot); });
    roots.forEach(process);
    var pending = new Set(), scheduled = false;
    function flush() {
      scheduled = false;
      var list = Array.from(pending), listSet = new Set(list);
      pending.clear();
      list.forEach(function (root) {
        if (!root.isConnected) return;
        for (var parent = root.parentNode; parent; parent = parent.parentNode) if (listSet.has(parent)) return;
        process(root);
      });
    }
    var options = { childList: true, subtree: true, characterData: true };
    if (arabicPage) { options.attributes = true; options.attributeFilter = displayAttributes; }
    var observer;
    function handle(mutations) {
      var lastTarget = null, lastSkip = false;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.target === body) {
          // An overlay appended to <body> (studio workspace, sheets, sticky bar): convert it now and watch it.
          for (var b = 0; b < mutation.addedNodes.length; b++) {
            var overlay = mutation.addedNodes[b];
            if (overlay.nodeType !== 1 || overlaySkip[overlay.tagName.toUpperCase()]) continue;
            if (overlay.id === 'itoris_dynamicproductoptions' || overlay.matches(skipSelector)) { rememberSkipRoot(overlay); continue; }
            pending.add(overlay);
            observer.observe(overlay, options);
          }
          continue;
        }
        var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        if (!target) continue;
        if (target !== lastTarget) { lastTarget = target; lastSkip = inSkipRoot(target) || !!target.closest(skipSelector); }
        if (lastSkip) continue;
        if (mutation.type === 'attributes') {
          var value = mutation.target.getAttribute(mutation.attributeName);
          if (value !== null && nonWesternNumeral.test(value) && !mutation.target.closest(attributeIgnoredParent)) {
            var normalized = westernAmount(value);
            if (normalized !== value) mutation.target.setAttribute(mutation.attributeName, normalized);
          }
          continue;
        }
        if (mutation.type === 'characterData') {
          if (candidate.test(mutation.target.nodeValue || '')) pending.add(mutation.target);
          continue;
        }
        var added = mutation.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 3) { if (candidate.test(n.nodeValue || '')) pending.add(n); }
          else if (n.nodeType === 1) {
            if (n.id === 'itoris_dynamicproductoptions' || n.matches(skipSelector)) rememberSkipRoot(n);
            else if (!skipTags[n.tagName]) pending.add(n);
          }
        }
      }
      if (pending.size && !scheduled) { scheduled = true; requestAnimationFrame(flush); }
    }
    observer = new MutationObserver(handle);
    // PF-13 "disconnect after init": on pages without a studio or a cart page (home, collections, search, content), every
    // price in #MainContent is server markup and no script prints money text there once the page has loaded (probe 21 Oct,
    // rebuild/v2/qa/bugs-price-facts/refine1/latetext-*.json: the only late money text is the cart drawer's). There
    // #MainContent gets its own observer, disconnected 4 s after window load: it still catches the load-time rewrites
    // (klik-transformation's translate() resets klik-ui-copy text on load), then stops. The cart drawer, the header
    // search results and the overlays appended to <body> stay observed; a section the theme editor reloads and product
    // recommendations are converted when they arrive. Product pages (studios print Intl text) and /cart keep the full
    // observer.
    var settled = /(?:^|\s)template-(?:index|collection|search|page|blog|article|list-collections|404)(?:\s|$)/.test(body.className);
    var mainObserver = settled ? new MutationObserver(handle) : observer;
    roots.forEach(function (root) { (root.id === 'MainContent' ? mainObserver : observer).observe(root, options); });
    if (settled) {
      var settle = function () { setTimeout(function () { handle(mainObserver.takeRecords()); mainObserver.disconnect(); }, 4000); };
      if (document.readyState === 'complete') settle();
      else window.addEventListener('load', settle, { once: true });
      var later = function (root) { if (root && root.nodeType === 1) { pending.add(root); if (!scheduled) { scheduled = true; requestAnimationFrame(flush); } } };
      document.addEventListener('shopify:section:load', function (event) { later(event.target); });
      document.addEventListener('recommendations:loaded', function () { later(document.getElementById('MainContent')); });
    }
    if (roots[0] !== body) {
      observer.observe(body, { childList: true });
      // Overlays a script appended to <body> before this script ran.
      Array.prototype.forEach.call(body.children, function (child) {
        if (overlaySkip[child.tagName.toUpperCase()] || roots.some(function (root) { return child === root || child.contains(root); })) return;
        if (child.matches('dialog, [role="dialog"], [aria-modal="true"]')) { process(child); observer.observe(child, options); }
      });
    }
  }

  window.KlikMoney = Object.freeze({
    format: format, text: text, node: node, html: html, campaign: campaign,
    cents: shown, config: function () { return Object.assign({}, readConfig()); }
  });
  window.KlikFacts = Object.freeze({ get: fact });

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
